import { useState } from "react"

import { ParadiseDeleteLLMPromptDialog } from "src/components/Paradise/ParadiseLLMPrompts/ParadiseLLMPromptDetails/ParadiseDeleteLLMPromptDialog"
import { ParadiseSetDefaultDialog } from "src/components/Paradise/ParadiseLLMPrompts/ParadiseLLMPromptDetails/ParadiseSetDefaultDialog"
import { DropdownListButton, IOption } from "src/ui/Button/DropdownListButton"

export function ParadiseLLMPromptActions({ promptId }: { promptId: string }) {
  const [showSetDefaultDialog, setShowSetDefaultDialog] = useState(false)
  const [showDeleteDialog, setShowDeleteDialog] = useState(false)

  const options: IOption<"delete-prompt" | "set-as-default">[] = [
    {
      name: "Set as default",
      value: "set-as-default",
      onClick: () => {
        setShowSetDefaultDialog(true)
      },
    },
    {
      name: "Delete prompt",
      value: "delete-prompt",
      onClick: () => {
        setShowDeleteDialog(true)
      },
      color: "destructive",
    },
  ]

  return (
    <div>
      <DropdownListButton displayValue="Prompt actions" options={options} />

      {showDeleteDialog && (
        <ParadiseDeleteLLMPromptDialog
          onClose={() => setShowDeleteDialog(false)}
          promptId={promptId}
        />
      )}

      {showSetDefaultDialog && (
        <ParadiseSetDefaultDialog
          onClose={() => setShowSetDefaultDialog(false)}
          promptId={promptId}
        />
      )}
    </div>
  )
}
